/**
 * NoticeBanner — Contextual info / warning / error banner with a colour left border.
 *
 * Props:
 *   variant  'info' | 'warning' | 'error'  (default: 'info')
 *   children ReactNode
 */
export default function NoticeBanner({ variant = 'info', children }) {
  return (
    <div className={`notice-banner ${variant}`} role="note">
      {children}
    </div>
  )
}
